function setSelectedRowsError() {
  const error = new Error(
    'The function setSelectedRows was not defined for TetoGrid'
  );
  // eslint-disable-next-line no-console
  console.error(error);
  return error;
}
export default setSelectedRowsError;
